import Vue from 'vue'
import VueRouter from 'vue-router'

import GoogleMapRaw from './components/GoogleMapRaw.vue';
import Landing from './components/Landing.vue';

import Login from './components/Login.vue';
import Logout from './components/authentication/Logout.vue';

import CandidateRegistration from './components/candidates/CandidateRegistration.vue';
// import CandidateProfile from './components/candidates/CandidateProfile.vue';
import CandidateDashboard from './components/candidates/Dashboard.vue';
import CandidateApplicationForm from './components/candidates/ApplicationForm';

import EmployerRegistration from './components/employers/Registration.vue';
import EmployerDashboard from './components/employers/Dashboard.vue';
import EmployerPublicProfile from './components/employers/profile/PublicProfile.vue';

import EmployerApplicationForm from './components/employers/applications/FamilyForm.vue'
import ClientApplicationPermanentNanny from './components/employers/applications/PermanentNanny.vue';
import ClientApplicationNannyOnCall from './components/employers/applications/NannyOnCall.vue';
import ClientApplicationInterimCare from './components/employers/applications/InterimCare.vue';

import MedicalRelease from './components/employers/documents/MedicalRelease';

import AgentDashboard from './components/agents/Dashboard.vue';
import StripeConnectConfirmation from './components/agents/StripeConnectConfirmation'

import JobBoard from './components/jobBoard/JobBoard.vue';
import Job from './components/jobBoard/Job.vue';
import EditJob from './components/employers/jobs/JobForm.vue';
import OrganizationBoard from './components/organizationBoard/OrganizationBoard.vue';

import Blog from './components/blog/Blog.vue';
import BlogPost from './components/blog/BlogPost.vue';
import NewBlogPost from './components/blog/NewBlogPost.vue';
import BlogForm from './components/blog/BlogPostForm.vue';
import EditBlogPost from './components/blog/EditBlogPost.vue';

import EventBoard from './components/events/EventBoard.vue';
import Event from './components/events/Event.vue';
import EditEvent from './components/events/EventForm.vue';

import About from './components/general/About.vue';
import Team from './components/general/Team.vue';
import What from './components/general/What.vue';
import Privacy from './components/general/Privacy.vue';
import Terms from './components/general/Terms.vue';
import Contact from './components/general/Contact.vue'
import Content from './components/general/Content.vue';
import CreateContent from './components/general/CreateContent.vue';

import PasswordResetRequest from './components/password/PasswordResetRequest.vue';
import PasswordReset from './components/password/PasswordReset.vue';

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Landing, name: 'Home' },
  { path: '/map', component: GoogleMapRaw },

  // { path: '/opportunities', component: GoogleMapRaw },

  { path: '/login', component: Login, name: 'Login' },
  { path: '/logout', component: Logout, name: 'Logout' },

  { path: '/candidate-registration', component: CandidateRegistration, name: 'Candidate Registration' },
  // { path: '/user', component: CandidateProfile, name: 'Candidate Dashboard' },
  { path: '/user', component: CandidateDashboard, name: 'Candidate Dashboard' },
  { path: '/user/:id', component: CandidateDashboard, name: 'Candidate Viewable Dashboard' },
  { path: '/nanny-application-form', component: CandidateApplicationForm, name: 'Candidate Application Form' },

  { path: '/employer-registration', component: EmployerRegistration, name: 'Employer Registration' },
  { path: '/family-dashboard', component: EmployerDashboard, name: 'Employer Dashboard' },
  { path: '/organization/:id', component: EmployerPublicProfile, name: 'Employer Public Profile' },

  { path: '/family-form', component: EmployerApplicationForm, name: 'Employer Application Form' },
  { path: '/client-application-permanent-nanny', component: ClientApplicationPermanentNanny, name: 'Client Application Permanent Nanny' },
  { path: '/client-application-nanny-on-call', component: ClientApplicationNannyOnCall, name: 'Client Application Nanny on Call' },
  { path: '/client-application-interim-care', component: ClientApplicationInterimCare, name: 'Client Application Interim Care' },

  { path: '/medical-release', component: MedicalRelease, name: 'Medical Release' },

  { path: '/agent-dashboard', component: AgentDashboard, name: 'Agent Dashboard' },
  { path: '/stripe-connect-confirmation', component: StripeConnectConfirmation, name: 'Stripe Connect Confirmation' },

  // { path: '/opportunities', component: JobBoard, name: 'Job Board' },
  { path: '/jobs', component: JobBoard, name: 'Job Board' },
  { path: '/opportunities/:type/:country/:topic', component: JobBoard, name: 'Search Job Board' },
  // { path: '/opportunity/:id', component: Job, name: 'Job' },
  { path: '/job/:id', component: Job, name: 'Job' },
  { path: '/edit-opportunity/:id', component: EditJob, name: 'Edit Job' },
  { path: '/organizations', component: OrganizationBoard, name: 'Organization Board' },
  { path: '/organizations/:type/:country/:topic', component: OrganizationBoard, name: 'Search Organization Board' },

  { path: '/global-health-events', component: EventBoard, name: 'Events' },
  { path: '/events/:type/:country/:topic', component: EventBoard, name: 'Search Events' },
  { path: '/event/:id', component: Event, name: 'Event' },
  { path: '/edit-event/:id', component: EditEvent, name: 'Edit Event' },

  // { path: '/blog', component: Blog, name: 'Blog' },
  { path: '/global-health-news-career-advice', component: Blog, name: 'Blog' },
  { path: '/blog-post/:id', component: BlogPost, name: 'Blog Post' },
  { path: '/new-blog-post', component: NewBlogPost, name: 'New Blog Post' },
  { path: '/edit-blog-post/:id', component: EditBlogPost, name: 'Edit Blog Post' },

  { path: '/about-us', component: About, name: 'About Us' },
  { path: '/team', component: Team, name: 'Team' },
  // { path: '/what-is-global-health', component: What, name: 'What is Global Health' },
  { path: '/privacy-policy', component: Privacy, name: 'Privacy Policy' },
  { path: '/terms-and-conditions', component: Terms, name: 'Terms and Conditions' },
  { path: '/contact', component: Contact, name: 'Contact' },

  { path: '/reset-password', component: PasswordResetRequest, name: 'Password Reset Request' },
  { path: '/reset-password/:token', component: PasswordReset, name: 'Password Reset' },

  { path: '/create-content', component: CreateContent, name: 'Create Content' },
  { path: '/:slug', component: Content, name: 'Content' },
]

export default new VueRouter({mode: 'history', routes})



// WEBPACK FOOTER //
// ./src/router.js